<template>
    <div>    
        <div class="banner-box">    
            <el-carousel :interval="5000" arrow="never" :height="'calc(100vw / (1920 / 942) )'">
                <el-carousel-item v-for="item in swiperData" :key="item.id">
                    <img  :src="item.image" alt="" style="cursor: pointer;width: 100%;" @click="handleClickJump(item.link)" />
                </el-carousel-item>
            </el-carousel>
        </div>

        <div class="product-list flex">
            <div class="product-box flex" :style="'left:'+(xleft)+'px'" id="productbox">
                <div class="flex" v-for="(item, index) in productArr" :key="'item' + index" @click="handleClickProduct(item)">
                    <div class="product-item">
                        <img class="icon" :src="item.logo" alt="" />
                        <div class="name" v-html="item.subProductName"></div>
                        <div class="desc flex">
                            {{ item.trait ? item.trait[0] : "" }}
                            <div class="shortLine"></div>
                            {{ item.trait ? item.trait[1] : "" }}
                        </div>
                    </div>
                    <div class="line" v-if="index != 5"></div>
                </div>
            </div>
        </div>


        <div>
            <div class="cad-title flex cflex">解决方案</div>
            <div class="plans flex" ref="planScroll">
                <div class="flex">
                    <div
                        class="plan-item"
                        v-for="(item, index) in planArr"
                        :key="index"
                        :style="'background:url(' + item.homeDisplay + ') center;cursor:pointer;'"
                        @click="handleJumpPlan(item.id)"
                    >
                        <div class="title">{{ item.schemeName }}</div>
                        <div class="desc">
                            {{ item.schemeDescribe }}
                        </div> 
                        <div class="more" >
                            在线咨询 <img style="margin-left: .09rem" src="@/assets/images/more-icon.png" alt="" width="auto"/>
                        </div>                       
                    </div>
                </div>
            </div>
        </div>


        <div>
            <div class="cad-title flex cflex">经典案例</div>
            <div class="cases flex" ref="planScroll">
                <div class="flex">
                    <div
                        class="case-item"
                        v-for="(item, index) in casesArr"
                        :key="index"
                        @click="handleClickJump(item.link)"
                    >
                        <img class="case-img" :src="item.image" alt="" />
                        <div class="desc" >
                            {{ item.title }}
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div>
            <div class="cad-title flex cflex">成功用户</div>
            <div class="cases flex">
                <img src="@/assets/images/usser-bg.png" alt="" style="width: 100%;">
            </div>
        </div>

        

        

        
    </div>  
</template>
<script>
export default {    
    data() {
        return {
            swiperData: [],
            productArr: [],
            fontColor: [
				"管综",
				"快模",
				"工规报建",
				"报建",
				"管网",
				"协同",
				"报建交付",
				"云族",
				"管线",
				"数字化交付",
				"AI数字",
				"可视化",
				"软件集成"
			],
            xleft:0,

            planArr:[],
            casesArr:[],
            

        
        }
    },
    created() {
        this.getSwiperData();
        this.getProducts();
        this.getPlanListData();
        this.getCasesListData();

    },
    mounted(){
        var that = this;
        var productbox = document.getElementById("productbox");
        var x = 0;
        var startX = 0;
        productbox.addEventListener('touchstart', function(e){
            startX = e.targetTouches[0].pageX;
            x = this.offsetLeft;
            console.log('开始了',startX,x)
        }) 
        productbox.addEventListener('touchmove', function(e){
            var moveX = e.targetTouches[0].pageX - startX;
            that.xleft = x + moveX;
            if(that.xleft > 0)that.xleft = 0;
            if(that.xleft < -746) that.xleft = -746;
            e.preventDefault();
        })

    },
    methods:{        
        getSwiperData() {
			this._get(this.API.swiperData + "?pageNo=1&pageSize=100").then((res) => {
				if (res.code == 200) {
					this.swiperData = res.data.records;
				}
			});
		},
        getProducts() {
			this._get(this.API.productList + "?pageNo=1&pageSize=100").then((res) => {
				// console.log("产品列表=====", res);
				if (res.code == 200) {
					let products = res.data.records;
					products.forEach((item) => {
						let font = this.fontColor.find((el) => {
							return item.productName.indexOf(el) > -1;
						});
						if (font) {
							item.subProductName = item.productName.replace(
								font,
								"<span style=font-size:.33rem;color:blue>" + font + "</span>"
							);
						} else {
							item.subProductName = item.productName;
						}
						let trait = item.productTrait ? item.productTrait.split("|") : [];
						item.trait = trait;
					});
					this.productArr = products;
				}
			});
		},
        getPlanListData() {
			this._get(this.API.planList + "?pageNo=1&pageSize=100").then((res) => {
				if (res.code == 200) {
					this.planArr = res.data.records;
				}
			});
		},
        handleClickJump(link) {
			window.open(link);
		},
        handleJumpPlan(id) {			
            this.$router.push({ name: "empty" });  
            setTimeout(()=>{
                this.$store.dispatch("setMenuInd",2)  
                this.$router.push({ name: "phonePlan", query: { id } });
                window.scrollTo(0, 0);
            },0)
		},
        getCasesListData() {
			this._get(this.API.caseList + "?pageNo=1&pageSize=5").then((res) => {
				if (res.code == 200) {
					let arr = res.data.records
					this.casesArr = arr.splice(0,4);//只显示4个，原来是5个
				}
			});
		},
        handleClickProduct(pro){
            this.$store.dispatch("setMenuInd",1)
            this.$router.push({ name: "phoneProduct", query: { id:pro.id } });
            window.scrollTo(0, 0);
        },        
    }
}
</script>
<style scope lang="less">
.banner-box{
    position: relative;
    height: calc(100vw / (1920 / 942) );
    overflow: hidden;
    /deep/.el-carousel--horizontal{
        height: 100%;
    }
    /deep/.el-carousel__container {
        position: relative;        
        height: 100%;
    }
}
.product-list{
    width: 100%;
    height: 2.3rem;
    overflow: hidden;
    position: relative;
    .product-box{
        position: absolute;
        width: auto;
        height: 100%;        
        top: 0;   
        
        .product-item {
            width: 3.7rem;
            display: flex;
            flex-direction: column;
            align-items: center;
            cursor: pointer;
            .icon {
                width: .6rem;
                height: .6rem;
                display: block;
            }
            .name {
                color: #000;
                font-size: .33rem;
                margin-top: .12rem;
            }
            .desc {
                color: #000;
                font-size: .3rem;
                margin-top: .05rem;
            }
            .shortLine {
                width: 1px;
                height: .3rem;
                margin: 0 5px;
                background: linear-gradient(180deg, rgba(216, 216, 216, 0) 0%, #d8d8d8 48%, rgba(216, 216, 216, 0) 100%);
            }
        }
    }
}
.cad-title{
    font-size: .6rem;
    padding: 1rem 0;
}
.plans {
		width: 100%;
		margin: 0 auto;
		overflow-x: auto;
		.plan-item {
			width: 5rem;
			height: 7rem;
			margin-right: .6rem;
			&:last-child {
				margin-right: 0;
			}
			.title {
				color: #3d3d3d;
				font-size: .42rem;
				margin-top: .4rem;
				padding: 0 .5rem;
				.text-ellipsis();
			}
			.desc {
				height: 3rem;
				margin-top: .2rem;
				padding: 0 .5rem;
				font-size: .33rem;
				line-height: 20px;
				.text-ellipsis();
			}
			.more {
				color: @main-color;
				font-size: .5rem;
				margin-top: .5rem;
				margin-left: .5rem;
				display: flex;
				align-items: center;
				cursor: pointer;
			}
		}
	}
.cases {
		width: 100%;		
		margin: 0 auto;
		overflow-x: auto;
		.case-item {			
            width: 5rem;
			height: 5rem;
            margin-right: .6rem;
			&:last-child {
				margin-right: 0;
			}
			.case-img {
				width: 100%;
				height: 3rem;
				display: block;
			}
			.desc {
				width: 100%;
				font-size: .33rem;
				color: #93a2bc;
				height: auto;
				margin-top: .1rem;
				.text-ellipsis();
			}
			
			&:hover {
				.desc {
					color: #3d3d3d;
				}
			}
		}
	}
</style>